module.exports = "/_next/static/images/Connections@2x-0fcd09e2209450f5f554126bfca54a46.webp";